import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as styles from './AdTypeIcon.scss';

var AdTypeIcon = /*#__PURE__*/function (_Component) {
  _inherits(AdTypeIcon, _Component);

  var _super = _createSuper(AdTypeIcon);

  function AdTypeIcon() {
    _classCallCheck(this, AdTypeIcon);

    return _super.apply(this, arguments);
  }

  _createClass(AdTypeIcon, [{
    key: "render",
    value:
    /** *********************************************************
     RENDER
     ***********************************************************/
    function render() {
      var _this$props = this.props,
          adType = _this$props.adType,
          source = _this$props.source;
      var icon = null;

      if (source === 'fb') {
        if (adType === 'LEAD_GENERATION') {
          icon = /*#__PURE__*/React.createElement("i", {
            className: "icon ion-funnel"
          });
        } else if (adType === 'PAGE_LIKES') {
          icon = /*#__PURE__*/React.createElement("i", {
            className: "fa fa-thumbs-up"
          });
        } else if (adType === 'POST_ENGAGEMENT') {
          icon = /*#__PURE__*/React.createElement("i", {
            className: "icon ion-arrow-graph-up-right"
          });
        } else if (adType === 'WEBSITE_TRAFFIC') {
          icon = /*#__PURE__*/React.createElement("i", {
            className: "fa fa-mouse-pointer"
          });
        } else if (adType === 'LINK_CLICKS') {
          icon = /*#__PURE__*/React.createElement("i", {
            className: "fa fa-mouse-pointer"
          });
        } else if (adType === 'BRAND_AWARENESS') {
          icon = /*#__PURE__*/React.createElement("i", {
            className: "fa fa-institution"
          });
        } else if (adType === 'APP_INSTALLS') {
          icon = /*#__PURE__*/React.createElement("i", {
            className: "fa fa-save"
          });
        } else if (adType === 'CONVERSIONS') {
          icon = /*#__PURE__*/React.createElement("i", {
            className: "fa fa-money"
          });
        } else if (adType === 'EVENT_RESPONSES') {
          icon = /*#__PURE__*/React.createElement("i", {
            className: "fa fa-calendar-check-o"
          });
        } else if (adType === 'LOCAL_AWARENESS') {
          icon = /*#__PURE__*/React.createElement("i", {
            className: "fa fa-map-marker"
          });
        } else if (adType === 'OFFER_CLAIMS') {
          icon = /*#__PURE__*/React.createElement("i", {
            className: "fa fa-handshake-o"
          });
        } else if (adType === 'PRODUCT_CATALOG_SALES') {
          icon = /*#__PURE__*/React.createElement("i", {
            className: "fa fa-shopping-cart"
          });
        } else if (adType === 'VIDEO_VIEWS') {
          icon = /*#__PURE__*/React.createElement("i", {
            className: "fa fa-video-camera"
          });
        }
      } else if (source === 'adsPlanner') {
        if (adType === 'LEADS') {
          icon = /*#__PURE__*/React.createElement("i", {
            className: "icon ion-funnel"
          });
        } else if (adType === 'PAGE_LIKES') {
          icon = /*#__PURE__*/React.createElement("i", {
            className: "fa fa-thumbs-up"
          });
        } else if (adType === 'CUSTOM_POSTS') {
          icon = /*#__PURE__*/React.createElement("i", {
            className: "icon ion-arrow-graph-up-right"
          });
        } else if (adType === 'SUBSCRIBED_POSTS') {
          icon = /*#__PURE__*/React.createElement("i", {
            className: "icon ion-arrow-graph-up-right"
          });
        } else if (adType === 'WEBSITE_TRAFFIC') {
          icon = /*#__PURE__*/React.createElement("i", {
            className: "fa fa-mouse-pointer"
          });
        } else if (adType === 'UNCATEGORIZED') {
          icon = /*#__PURE__*/React.createElement("i", {
            className: "icon ion-wand"
          });
        } else if (adType === 'BRAND_AWARENESS') {
          icon = /*#__PURE__*/React.createElement("i", {
            className: "fa fa-institution"
          });
        } else if (adType === 'APP_INSTALLS') {
          icon = /*#__PURE__*/React.createElement("i", {
            className: "fa fa-save"
          });
        } else if (adType === 'CONVERSIONS') {
          icon = /*#__PURE__*/React.createElement("i", {
            className: "fa fa-money"
          });
        } else if (adType === 'EVENT_RESPONSES') {
          icon = /*#__PURE__*/React.createElement("i", {
            className: "fa fa-calendar-check-o"
          });
        } else if (adType === 'LOCAL_AWARENESS') {
          icon = /*#__PURE__*/React.createElement("i", {
            className: "fa fa-map-marker"
          });
        } else if (adType === 'OFFER_CLAIMS') {
          icon = /*#__PURE__*/React.createElement("i", {
            className: "fa fa-handshake-o"
          });
        } else if (adType === 'PRODUCT_CATALOG_SALES') {
          icon = /*#__PURE__*/React.createElement("i", {
            className: "fa fa-shopping-cart"
          });
        } else if (adType === 'VIDEO_VIEWS') {
          icon = /*#__PURE__*/React.createElement("i", {
            className: "fa fa-video-camera"
          });
        }
      }

      return icon ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(styles["iconWrap_".concat(this.props.size)], " ").concat(styles.iconWrap, " ").concat(styles["icon_".concat(adType)]),
        style: this.props.style
      }, icon) : null;
    }
  }]);

  return AdTypeIcon;
}(Component);

_defineProperty(AdTypeIcon, "defaultProps", {
  size: 'medium',
  source: 'fb',
  style: {}
});

export default AdTypeIcon;